<template>

<v-content class="">
  <v-container class="mainArea">
    <v-layout class="upper-row" row wrap>
      <v-flex class="contentWrapper" xs12 sm6>
        <div class="caption text-left contentContainer mx-6">
          <h1 class="display-3 font-weight-bold black--text">Als KI-Trainer registrieren</h1>
          <p
            class="body-1 my-10"
          >Liebe KI-Trainer,<br> bitte erstellt Euch einen Account und tragt Euch hier als KI-Trainer ein. Dadurch können wir alle Kontaktdaten, Kompetenzen und Schwerpunkte sammeln, um Suchen und Empfehlungen für Unternehmen anbieten zu können. <br>Vielen Dank für Eure Mitarbeit!</p>
          <p>Die von Euch angegebenen Daten werden dann online zur Verfügung gestellt und sind öffentlich einsehbar. Informationen zum Datenschutz findet ihr unter dem entsprechenden Link in der Fußzeile.</p>
           <v-btn v-if="!loggedIn" to="/signup"  large color="accent mr-3">Jetzt registrieren</v-btn>

          <v-btn v-if="!loggedIn" to="/signin" large text color="primary ml-3">Hier anmelden &#8594;</v-btn>
          <v-btn v-if="loggedIn" to="/enterdetails" large text color="accent mr-3">Jetzt eintragen &#8594;</v-btn>
        </div>
      </v-flex>

      <v-flex class="imageWrapper" xs12 sm6>
        <v-row class="imageContainer text-center" align="center" justify="center">
          <v-img
            contain
            :src="require('../assets/KITrainerIllustration.png')"
            aspect-ratio="1"
            max-width="500px"
          ></v-img>
        </v-row>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex class="IconWrapper" xs12 md12>
        <div class="d-flex justify-center">

          <div class="px-12" xs-2 sm-2>
            <a href="https://digitalzentrum-kaiserslautern.de/" target="_blank">
              <img
                class="partnerImg"
                :src="require('../assets/MKKLogo.png')"
                alt="Mittelstand 4.0 Logo"
              />
            </a>
          </div>

          <div class="px-12" xs-2 sm-2>
            <a href="https://www.bmwi.de/Navigation/DE/Home/home.html" target="_blank">
              <img
                class="bmwkImg"
                :src="require('../assets/bmwk_transparent.png')"
                alt="Bundesministerium für Wirtschaft und Energie Logo"
              />
            </a>
          </div>

<div class="px-12" xs-2 sm-2>
            <a href="https://www.mittelstand-digital.de/MD/Navigation/DE/Home/home.html" target="_blank">
              <img
                class="partnerImg"
                :src="require('../assets/mittelstandDigitalLogo.png')"
                alt="Bundesministerium für Wirtschaft und Energie"
              />
            </a>
          </div>



        </div>
      </v-flex>
    </v-layout>
  </v-container>

  </v-content>
</template>

<script>
import auth from "../auth";
export default {
  name: "Landing",
  data(){
    return{
      loggedIn: auth.loggedIn(),
    }
  }
};
</script>

<style scoped>
.mainArea {
  height: calc(100vh - 110px);
}

.contentContainer {
  margin: auto;
  padding: 10px;
  position: absolute;
  width: 80%;
  height: auto;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.imageContainer {
  margin: auto;
  padding: 10px;
  position: absolute;
  width: 100%;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.imageWrapper {
  animation: ImageAnimation 1.5s forwards 0s ease;
    height: calc(88vh - 110px);
  position: relative;
}

.contentWrapper {
  animation: ContentAnimation 1.5s forwards 0s ease;
  height: calc(88vh - 110px);
  position: relative;
}

.IconWrapper {
  height: 12vh;
  animation: ContentAnimation 1.5s forwards 0s ease;
}

.partnerImg {
}

.partnerImg {
  opacity: 0.6;
  height: 50px;
  /* filter: url(filters.svg#grayscale); Firefox 3.5+ */
  filter: gray; /* IE5+ */
  -webkit-filter: grayscale(0.8); /* Webkit Nightlies & Chrome Canary */
  -webkit-transition: all 0.3s ease;
}


.bmwkImg {
  opacity: 0.6;
  margin-top: -50px;
  height: 150px;
  /* filter: url(filters.svg#grayscale); Firefox 3.5+ */
  filter: gray; /* IE5+ */
  -webkit-filter: grayscale(0.8); /* Webkit Nightlies & Chrome Canary */
  -webkit-transition: all 0.3s ease;
}

.bmwkImg:hover {
  opacity: 1;
  filter: none;
  -webkit-filter: grayscale(0);
}

.partnerImg:hover {
  opacity: 1;
  filter: none;
  -webkit-filter: grayscale(0);
}


/*** ANIMATIONS ***/

@keyframes ImageAnimation{
    0%{
        transform: translateX(20%);
        opacity: 0;
        }
    100%{
        transform: rotate(xx) translateX(0%);
        opacity: 1;
        }
}

@keyframes ContentAnimation{
    0%{
        transform: translateY(-20%);
        opacity: 0;
        }
    100%{
        transform: translateY(0%);
        opacity: 1;
        }
}



a:hover {
  text-decoration: none !important;
}
</style>
